"use strict";
var Observable_1 = require('../../Observable');
var fromEvent_1 = require('../../observable/fromEvent');
Observable_1.Observable.fromEvent = fromEvent_1.fromEvent;
//# sourceMappingURL=fromEvent.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/add/observable/fromEvent.js
// module id = 615
// module chunks = 4